import { Component, output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lib-user-menu-dropdown',
  template: `
    <div
      class="absolute right-0 mt-2 w-48 bg-gray-800 rounded-lg shadow-xl border border-gray-700 z-[60]"
      role="menu"
    >
      <div class="py-2">
        <button
          type="button"
          (click)="profile.emit()"
          class="w-full text-left px-4 py-2 text-sm text-gray-200 hover:bg-gray-700 hover:text-white transition-colors duration-200 focus:outline-none focus:bg-gray-700"
          role="menuitem"
        >
          <div class="flex items-center">
            <svg
              class="w-4 h-4 mr-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            Profile
          </div>
        </button>

        <hr class="border-gray-600 mx-2" />

        <button
          type="button"
          (click)="signOut.emit()"
          class="w-full text-left px-4 py-2 text-sm text-gray-200 hover:bg-gray-700 hover:text-red-400 transition-colors duration-200 focus:outline-none focus:bg-gray-700"
          role="menuitem"
        >
          <div class="flex items-center">
            <svg
              class="w-4 h-4 mr-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
            Sign out
          </div>
        </button>
      </div>
    </div>
  `,
})
export class UserMenuDropdownComponent {
  profile = output<void>();
  signOut = output<void>();
}
